import React, { useState } from "react";
import { Menu, X, ChevronDown } from "lucide-react";
import { Link, useNavigate } from "react-router-dom";
import "./HeroSection.css";
import SideNavBar from "../sideNavBar/SideNavBar";
import { useAuth } from "../../context/auth";
const decorativeImage = "/images/00180.png";
const logoImage = "/images/logoOnBlack.png";

const HeroSection = ({
  title,
  description,
  showDecorative = true,
  variant = "default",
  activeNav = "home",
  onNavClick = () => {},
  onLoginClick = () => {},
  onGetStartedClick = () => {},
}) => {
  const navigate = useNavigate();
  const { isAuthenticated, user } = useAuth();
  const [sideNavOpen, setSideNavOpen] = useState(false);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const handleNavigation = (path) => {
    onNavClick(path);
    navigate(path);
  };

  const handleLogin = () => {
    navigate("/onboarding", { state: { mode: "login" } });
    closeSideNav();
  };

  const handleGetStarted = () => {
    navigate("/onboarding", { state: { mode: "signup" } });
    closeSideNav();
  };

  const toggleSideNav = () => {
    setSideNavOpen(!sideNavOpen);
  };

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const closeSideNav = () => {
    setSideNavOpen(false);
  };

  const getDashboardPath = () => {
    if (!user?.activeRole) return "/";
    return `/home/${user.activeRole}`;
  };

  return (
    <>
      <section className={`hero-section-same hero-section-same--${variant}`}>
        <header className="hero-section-same-header">
          <div className="hero-section-same-header-container">
            <div className="hero-section-same-logo">
              <div className="hero-section-same-logo-icon">
                <img
                  src={logoImage}
                  alt="Logo"
                  className="hero-section-same-landing-page-hero-logo"
                  onClick={() => handleNavigation("/")}
                />
              </div>
            </div>
            <nav className="hero-section__nav">
              <a
                href="/"
                className={
                  activeNav === "home" ? "hero-section-same-active" : ""
                }
                onClick={(e) => {
                  e.preventDefault();
                  handleNavigation("/");
                }}
              >
                Home
              </a>
              <a
                href="/explore"
                className={
                  activeNav === "explore" ? "hero-section-same-active" : ""
                }
                onClick={(e) => {
                  e.preventDefault();
                  handleNavigation("/explore");
                }}
              >
                Explore
              </a>
              <a
                href="/about-us"
                className={
                  activeNav === "about" ? "hero-section-same-active" : ""
                }
                onClick={(e) => {
                  e.preventDefault();
                  handleNavigation("/about-us");
                }}
              >
                About Us
              </a>
              <a
                href="/get-in-touch"
                className={
                  activeNav === "help" ? "hero-section-same-active" : ""
                }
                onClick={(e) => {
                  e.preventDefault();
                  handleNavigation("/get-in-touch");
                }}
              >
                Get Help
              </a>
            </nav>
            <div className="hero-section-same-header-buttons">
              {!isAuthenticated ? (
                <>
                  <button
                    className="hero-section-same-login-btn"
                    onClick={handleLogin}
                  >
                    Login
                  </button>
                  <button
                    className="hero-section-same-get-started-btn"
                    onClick={handleGetStarted}
                  >
                    Get Started
                  </button>
                </>
              ) : (
                <button
                  className="hero-section-same-dashboard-btn"
                  onClick={() => handleNavigation(getDashboardPath())}
                >
                  Dashboard
                </button>
              )}
            </div>

            <div
              className="hero-section-same-mobile-menu"
              onClick={toggleSideNav}
            >
              <div className="header-nav-hamburger">
                <Menu size={28} /> <div>Menu</div>
              </div>
            </div>
          </div>
        </header>

        <div className="hero-section__container">
          {showDecorative && (
            <div className="hero-section__decorative">
              <div className="decorative-shape">
                <img
                  src={decorativeImage}
                  alt="Decorative element"
                  className="landing_page_hero_section_decorative"
                />
              </div>
            </div>
          )}
          <div className="hero-section__content">
            <h1 className="hero-section__title">{title}</h1>
            <p className="hero-section__description">{description}</p>
          </div>
        </div>
      </section>

      <SideNavBar
        isOpen={sideNavOpen}
        onClose={closeSideNav}
        activeNav={activeNav}
        onNavClick={handleNavigation}
        onLoginClick={handleLogin}
        onCreateAccountClick={handleGetStarted}
        isAuthenticated={isAuthenticated}
        user={user}
      />
    </>
  );
};

export default HeroSection;